export default function Usdt() {
  return (
    <>
      <g clipPath="url(#clip0_665_395)">
        <path
          d="M13.0332 26.6152C20.2129 26.6152 26.0332 20.7949 26.0332 13.6152C26.0332 6.43553 20.2129 0.615234 13.0332 0.615234C5.8535 0.615234 0.0332031 6.43553 0.0332031 13.6152C0.0332031 20.7949 5.8535 26.6152 13.0332 26.6152Z"
          fill="#26A17B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5952 14.7395V14.7379C14.5058 14.7444 14.0452 14.772 13.0173 14.772C12.1967 14.772 11.619 14.7476 11.4159 14.7379V14.7403C8.25691 14.6014 5.89903 14.0513 5.89903 13.3932C5.89903 12.7359 8.25691 12.1858 11.4159 12.0444V14.1927C11.6223 14.2073 12.2138 14.2422 13.0312 14.2422C14.0118 14.2422 14.5034 14.2016 14.5952 14.1935V12.0461C17.7477 12.1866 20.0999 12.7367 20.0999 13.3932C20.0999 14.0513 17.7477 14.5997 14.5952 14.7395ZM14.5952 11.8226V9.90025H18.9941V6.96875H7.01703V9.90025H11.4159V11.8218C7.84091 11.9859 5.15234 12.6944 5.15234 13.5427C5.15234 14.3909 7.84091 15.0986 11.4159 15.2636V21.4239H14.5952V15.2619C18.1645 15.0978 20.8466 14.3901 20.8466 13.5427C20.8466 12.6952 18.1645 11.9876 14.5952 11.8226Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_665_395">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(0.0332031 0.615234)"
          />
        </clipPath>
      </defs>
    </>
  );
}
